import utils from '@/js/utils'

const singleMuPerimeter = 1000
const singleMuArea = 1000000 // single-sided

// cutMu factors
const cutEdgeMuFactor = 1.5 / 4 // 1.5 Mu = 180s or 3mins per 4000mm so divided by 4 to get linear metre
const topBaseMuFactor = 0.6 // detail cut for top and base
const sideMuFactor = 2.5 // detail cut for each side
const lightingCutMuFactor = 1.9 * 2 // detail cut for 2set of lighting (140s)

// finishMu factors
const laminateEdgeMuFactor = 2.46
const veneerEdgeMuFactor = 1
const veneerSingleSurfaceMuFactor = 1.075 //half of double surface = 2.15 / 2

// assembly and pack mu factors
const assemblyAndPackMuFactorPantry = 35 // roughly 35 * 120s = 4200s = 70min

export default {
  get(pantries, materials, taskType) {
    let mu = 0
    if (!pantries) return mu

    for (const pantry of pantries) {
      // check incomplete
      if (!pantry.pantryType || !pantry.carcass) continue

      // Calculate perimeter and surface once per pantry (for finish taskType)
      if (taskType == 'finish') {
        let pantryPerimeter = 0
        let pantrySurface = 0
        let hasAnyGrain = false

        // Calculate total perimeter and surface for finish taskType, and check for grain
        materials.forEach((material) => {
          if (!material.value || !material.thickness || !material.w || !material.h) return

          // Carcass
          if (material.id === pantry.carcass) {
            // exclude base
            pantryPerimeter += (pantry.h + pantry.d) * 2 * 2 + (pantry.w + pantry.d) * 2

            // shelves
            let adjShelfDepth
            let fixedShelfDepth
            switch (pantry.d) {
              case 367:
                adjShelfDepth = 300
                fixedShelfDepth = 300
                break
              case 591:
                adjShelfDepth = 300
                fixedShelfDepth = 400
                break
            }

            // if task type is finish, then only finish front edge for fixed shelf
            pantryPerimeter += (adjShelfDepth + pantry.w) * 2 * 2 + pantry.w

            if (material.hasGrain) {
              hasAnyGrain = true
              // only inside surface
              pantrySurface += pantry.d * pantry.h * 2 + pantry.d * pantry.w
              pantrySurface += adjShelfDepth * pantry.w * 2 + fixedShelfDepth * pantry.w
            }
          }

          // Base
          if (material.id === pantry.base) {
            pantryPerimeter += (pantry.w + pantry.d) * 2
            if (material.hasGrain) {
              hasAnyGrain = true
              pantrySurface += pantry.d * pantry.w
            }
          }

          // Back
          if (material.id === pantry.back) {
            if (material.hasGrain) {
              hasAnyGrain = true
              pantrySurface += pantry.w * pantry.h
            }
          }
        })

        // Apply finish MU once per pantry using total perimeter/surface
        const edgeMu = hasAnyGrain
          ? (pantryPerimeter / singleMuPerimeter) * veneerEdgeMuFactor
          : (pantryPerimeter / singleMuPerimeter) * laminateEdgeMuFactor
        const surfaceMu = pantrySurface > 0 ? (pantrySurface / singleMuArea) * veneerSingleSurfaceMuFactor : 0
        mu += edgeMu + surfaceMu
      }

      // Handle cut taskType per material
      if (taskType == 'cut') {
        materials.forEach((material) => {
          if (!material.value || !material.thickness || !material.w || !material.h) return

          let materialPerimeter = 0
          let cutMu = 0

          if (material.id === pantry.carcass) {
            // exclude base
            materialPerimeter += (pantry.h + pantry.d) * 2 * 2 + (pantry.w + pantry.d) * 2

            // shelves
            let adjShelfDepth
            let fixedShelfDepth
            switch (pantry.d) {
              case 367:
                adjShelfDepth = 300
                fixedShelfDepth = 300
                break
              case 591:
                adjShelfDepth = 300
                fixedShelfDepth = 400
                break
            }

            materialPerimeter += (adjShelfDepth + pantry.w) * 2 * 2 + (fixedShelfDepth + pantry.w) * 2

            // total edges
            cutMu += (materialPerimeter / singleMuPerimeter) * cutEdgeMuFactor
            // top and base
            cutMu += 2 * topBaseMuFactor
            // sides (incl. t-slot and shelf holes)
            cutMu += 2 * sideMuFactor
            // lighting
            if (pantry.lighting) {
              cutMu += lightingCutMuFactor
            }
          }

          if (material.id === pantry.base) {
            materialPerimeter += (pantry.w + pantry.d) * 2
          }

          if (material.id === pantry.back) {
            materialPerimeter += (pantry.w + pantry.h) * 2
            // back
            cutMu += (materialPerimeter / singleMuPerimeter) * cutEdgeMuFactor
          }

          // add to total mu
          mu += cutMu
        })
      }
      // calculating assembly mu in terms of per pantry
      if (taskType == 'assemble') {
        let assemblyMu = assemblyAndPackMuFactorPantry
        // if (pantry.preAssembled) assemblyMu *= 0.7 // hasnt got this feature yet
        mu += assemblyMu
      }
    }

    return utils.toFixedNumber(mu, 2)
  }
}
